<template>
  <a-card :bordered="false">
    <a-tabs v-model="activeKey">
      <a-tab-pane :key="1" tab="批量导单" @tabClick="tabClick(1)">
        <div>
          <div style="margin:20px 0 ">上传需要导入文件：</div>
          <div style="color:#d9001b;margin-bottom:20px;">建议： 一次建议最多100张订单，分批次进行导入。</div>
          <a-upload-dragger
            name="file"
            :multiple="true"
            :action="uploadUrl"
            :before-upload="handleBefore"
            :headers="headers"
            @change="handleChange"
            :remove="handleRemove"
            :file-list="fileList"
          >
            <p class="ant-upload-drag-icon" style="margin-bottom:10px;">
              <a-icon type="inbox"/>
            </p>
            <p class="ant-upload-text">拖拽或点击以导入批量发货文件</p>
            <p class="text-template"><span @click.stop="downloadFile">下载批量导单模板</span></p>
          </a-upload-dragger>

          <!--          <p style="margin-top:20px;">本次上传订单统计：<span class="text-primary">{{fileList.length}}</span>单</p>-->

          <div style="text-align:center;margin:60px 0 40px 0;">
            <a-button type="primary" @click="submitList">提交</a-button>
          </div>
        </div>
      </a-tab-pane>
      <a-tab-pane :key="2" tab="导单记录" @tabClick="tabClick(2)">
        <batchOrderList ref="child"></batchOrderList>
      </a-tab-pane>
    </a-tabs>


  </a-card>
</template>

<script>
import BatchOrderList from './BatchOrderList'
import formMixins from '../../../../utils/mixins/formMixins'

export default {
  name: 'BatchOrder',
  components: {
    BatchOrderList
  },
  mixins: [formMixins],
  data() {
    return {
      type: 1,
      uploadUrl: this.getAppConfig().baseUrl + 'base/uploadFile/' + this.$store.getters.userInfo.merchantId,
      headers: {
        token: this.$store.getters.token
      },
      errorList: [],
      fileList: [],
      activeKey: 1
    }
  },
  created() {
    this.$store.commit('SET_MENU_HEAD_CONFIG', [
      { name: 'ResourceControlList', title: '项目列表' },
      { name: 'PushOrder', title: '推送订单' },
      { name: 'BatchOrder', title: '批量导单' },
      { name: 'CommodityList', title: '商品列表' }
    ])
  },
  mounted() {
  },
  methods: {
    tabClick(key) {
      this.activeKey = key
      this.getLogUtils().logWithTag('key', key)
      this.$refs.child.refresh()
    },
    handleChange(info) {
      let fileList = [...info.fileList]
      fileList = fileList.slice(-1)
      fileList = fileList.map(file => {
        if (file.response) {
          file.url = file.response.url
        }
        return file
      })
      this.fileList = fileList
    },
    handleRemove(file) {
      const index = this.fileList.indexOf(file)
      const newFileList = this.fileList.slice()
      newFileList.splice(index, 1)
      this.fileList = newFileList
    },
    submitList() {
      if (this.fileList.length < 1) {
        this.$message.error('请先上传订单')
        return
      }
      if (this.fileList.length > 1) {
        this.$message.error('只能上传一份附件')
        return false
      }
      let parm = {
        fileName: this.fileList[0].name,
        filePath: this.fileList[0].response.data
      }
      this.getHttpServices().getOrderService().post('resources/order/upload/handworkOrder', parm)
        .then(res => {
          this.tabClick(2)
          this.$message.success('导入成功')
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    handleBefore(file) {
      if (this.handleBeforeUploadExcelFile(file)) {
        return true
      }
      return false
    },
    // 下载模板
    downloadFile() {
      window.open('https://imgb.woyoubooking.com/config/piliangdaodan.xlsx')
    }
  }
}
</script>
<style scoped>
.text-template {
  font-size: 16px;
  color: #FAAD14;
  font-weight: 400;
  text-align: right;
  padding-right: 20px;
}

.text-primary {
  color: #0000ff;
  font-size: 20px;
}

.text-danger {
  color: #d9001b;
  font-size: 20px;
}
</style>
